<div class="headDiv">
  <div class="title" [ngClass]="external ? '' : ''" [innerHTML]="getTrustedHTML(title)"></div>
</div>

<div class="main" [ngClass]="external ? 'externalCss' : ''" [innerHTML]="getTrustedHTML(description)"></div>